import { consumptionPeriods } from "./consumptionPreview";

// Presence check only; detailed time-series and schedule validation remains
// with the simulation engine. Never use an inactive imported profile.
export function consumptionReadiness(demand = {}) {
  if (demand.enabled === false) return "disabled";
  const profile = demand.loadProfile;
  const positive = value => Number.isFinite(Number(String(value).replace(",", "."))) && Number(String(value).replace(",", ".")) > 0;
  if (profile?.use !== false && profile?.values?.length) {
    return profile.values.some(positive) ? null : "missing";
  }
  const periods = consumptionPeriods(demand.inputType);
  const supplied = periods.some(({ key }) => positive(demand.monthly?.[key]));
  return supplied || positive(demand.baseLoadKw) ? null : "missing";
}

export function enableDemandForBtmSelection(cfg) {
  return { ...cfg, feasibility: { ...cfg.feasibility,
    technical: { ...cfg.feasibility?.technical,
      demand: { ...cfg.feasibility?.technical?.demand, enabled: true } } } };
}
